import { QueryKeyParam, createQueryKey } from '../../query';

const locationKeys = (scopeId: QueryKeyParam) =>
  createQueryKey({
    all: ['offers', 'categories', scopeId, 'locations'] as const,
    id: (locationId: QueryKeyParam) =>
      createQueryKey({
        all: ['offers', 'categories', scopeId, 'locations', locationId] as const,
        detail: ['offers', 'categories', scopeId, 'locations', locationId, 'detail'] as const,
      }),
  });

const merchantKeys = (scopeId: QueryKeyParam) =>
  createQueryKey({
    all: ['offers', 'categories', scopeId, 'merchants'] as const,
    id: (merchantId: QueryKeyParam) =>
      createQueryKey({
        all: ['offers', 'categories', scopeId, 'merchants', merchantId] as const,
        detail: ['offers', 'categories', scopeId, 'merchants', merchantId, 'detail'] as const,
      }),
  });
const categoriesKeys = () =>
  createQueryKey({
    all: ['offers', 'categories'] as const,
    id: (categoryId: QueryKeyParam) =>
      createQueryKey({
        all: ['offers', 'categories', categoryId] as const,
        locations: locationKeys(categoryId),
        merchants: merchantKeys(categoryId),
      }),
  });

export { categoriesKeys };
